export default __webpack_public_path__ + "static/media/avatar7.00e8f4f0.png";